import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import api from '../../services/api';
import { getMediaUrl, openFile, downloadFile } from '../../services/media';
import styles from './Book.module.css';

const Book = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/books/${id}`)
      .then((res) => setBook(res.data))
      .catch(() => setError('Книга не найдена'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className={styles.loading}>{t('common.loading')}</div>;
  if (error || !book) return <div className={styles.error}>{error || 'Книга не найдена'}</div>;

  return (
    <div className={styles.book}>
      <div className={styles.container}>
        <button onClick={() => navigate('/catalog')} className={styles.backButton}>
          ← {t('book.backToCatalog')}
        </button>

        <div className={styles.content}>
          {book.coverUrl && (
            <div className={styles.coverWrap}>
              <img src={getMediaUrl(book.coverUrl)} alt={book.title} className={styles.cover} />
            </div>
          )}
          <div className={styles.info}>
            <h1 className={styles.title}>{book.title}</h1>
            <p className={styles.author}>{t('book.author')}: {book.author}</p>

            <div className={styles.meta}>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>{t('book.year')}</span>
                <span className={styles.metaValue}>{book.year}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.metaLabel}>{t('book.language')}</span>
                <span className={styles.metaValue}>{book.language}</span>
              </div>
              {book.genres?.length > 0 && (
                <div className={styles.metaItem}>
                  <span className={styles.metaLabel}>{t('catalog.filterBySpecialty')}</span>
                  <span className={styles.metaValue}>{book.genres.map((g) => g.name).join(', ')}</span>
                </div>
              )}
            </div>

            {book.description && (
              <div className={styles.description}>
                <h3>{t('book.description')}</h3>
                <p>{book.description}</p>
              </div>
            )}

            {book.fileUrl && (
              <div className={styles.bookActions}>
                <button onClick={() => openFile(book.fileUrl)} className={styles.readButton}>
                  {t('book.read')}
                </button>
                <button
                  onClick={() => downloadFile(book.fileUrl, book.title)}
                  className={styles.downloadButton}
                >
                  Скачать
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
